import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const sessionInformation202310: BlogMetaData = {
  title: '2023年10・11月の説明会開催について',
  description: '2024年4月からの園児募集につき、保育園の説明会を開催します。',
  thumbnailUrl: '/img/first-view-image1.webp',
  filePath: buildBlogFilePath('2023_11-session-information'),
  category: BLOG_CATEGORY.NEWS,
};
